<div class="monograph-widget">
  <h3 class="c-widget-title c-heading c-heading-h3 mb-3">
    {{ 'accountOverview.product_monograph.title' | cxTranslate }}
  </h3>
  <a class="c-link" (click)="goToMonographPage()">
    {{ 'accountOverview.monographText' | cxTranslate }}
  </a>
</div>
